import { useAppSelector } from "redux/hooks";
import { selectSuccess } from "redux/slices/OtpSlice";

const useOtp = (): boolean => {
  const isOtp = useAppSelector(selectSuccess);

  return isOtp;
};

export default useOtp;
